// extracted by mini-css-extract-plugin
module.exports = {"player-icon-mask":"ed","playerIconMask":"ed","player-icon-box":"ee","playerIconBox":"ee"};